import styled from 'styled-components';
import { ThemeColours } from '../../../../../../../common/styles/ThemeColours';

const formatDistance = (distance: number) => {
  if (distance < 0.05) {
    return '50m';
  }

  if (distance < 1) {
    // round to nearest 50 metres
    return `${Math.round((distance * 1000) / 50) * 50}m`;
  }

  if (distance < 10) {
    // round to nearest .1 kilometre
    return `${Math.round(distance * 10) / 10}km`;
  }

  if (distance < 99) {
    // read to nearest kilometre
    return `${Math.round(distance)}km`;
  }

  return '+99km';
};

interface Props {
  distance?: number; // kilometres
}

export const Distance = ({ distance }: Props) => {
  if (!distance) {
    return null;
  }

  return <View>{formatDistance(distance)} &middot;&nbsp;</View>;
};

const View = styled.div`
  color: ${ThemeColours.mono700};
  display: inline;
  white-space: nowrap;
`;
